export default "__VITE_ASSET__ajHBgurs__"